import {createContext, ReactNode, useEffect, useState} from "react";

export interface Notification {
    name : string,
    date : string
}

interface State {
    notifications : Notification[],
    deleteNotification: (notification : Notification) => void,
    addNotification: (notification : Notification) => void,
    deleteNotifications: () => void
}

export const NotificationContext = createContext<State | undefined>(undefined)

interface Props {
    children: ReactNode;
}


export const NotificationProvider = ({ children } : Props) => {

    const [notifications, setNotifications] = useState<Notification[]>([])

    const deleteNotification = (notification: Notification) => {
        setNotifications(prev => prev.filter(n => n !== notification));
    };

    const addNotification = (notification: Notification) => {
        setNotifications(prev => [notification, ...prev]);
    };

    const deleteNotifications = () => {
        setNotifications([])
    }

    const value={
        notifications,
        deleteNotification,
        addNotification,
        deleteNotifications
    }

    return (
        <NotificationContext.Provider value={value}>
            {children}
        </NotificationContext.Provider>
    )
}